import MyAppInternal from '../../../components/MyAppInternal'
import Keyboard from '../../../src/Pages/Keyboard'
import Google from '../../../src/Pages/Keyboard/Google'
import { common_getProps } from '../../../components/common_getProps'
import kbLangSlugToKey from '../../../public/kbLangSlugToKey.json'

const Section = (props) => (
    <MyAppInternal {...props} sectionKey={'google'}>
        <Keyboard>
            <Google />
        </Keyboard>
    </MyAppInternal>
)

export async function getStaticProps(context) {
    return common_getProps(context)
}

export async function getStaticPathsByLocale(locale) {
    return {
        paths: Object.keys(kbLangSlugToKey[locale]).map((slug) => ({
            params: { kbLangSlug: encodeURI(slug) },
            locale
        })),
        fallback: true
    }
}

export async function getStaticPaths() {
    return getStaticPathsByLocale('en')
}

export default Section
